


































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import type { BaseEntry } from 'contentful';

import { useProductGroup } from '~/diptyqueTheme/composable/useProductGroup';
import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import { Logger } from '~/helpers/logger';
import type {
  HighlightEcomModel,
  ProductsGroupModel
} from '~/integrations/contentful/src/types';

export default defineComponent<{ sectionData: HighlightEcomModel & BaseEntry }>(
  {
    name: 'HighlightEcom',
    components: {
      VaimoHeading: () => import('atoms/VaimoHeading.vue'),
      VaimoTruncatedText: () => import('atoms/VaimoTruncatedText.vue'),
      VaimoProducts: () => import('organisms/VaimoProducts.vue')
    },
    props: {
      sectionData: {
        required: true,
        type: Object
      }
    },
    setup(props) {
      const { isDesktop } = useScreenSize();
      const { getTransformedData } = useProductGroup({});
      const productGroup = computed<ProductsGroupModel[]>(() => {
        try {
          return getTransformedData([props.sectionData?.productGroup]);
        } catch (e) {
          Logger.error('[HighlightEcom] Failed to get transformed data:', e);
          return [];
        }
      });
      const heading = computed<string>(() => props.sectionData?.heading || '');
      const headingLink = computed<string>(
        () => props.sectionData?.headingLink || ''
      );
      const description = computed(() => props.sectionData?.descr);
      const productsSKU = computed(() => productGroup.value?.[0]?.sku || []);
      const skuListType = computed(
        () => productGroup.value?.[0]?.type || 'listOfSku'
      );
      const nostoSlot = computed<string>(
        () => productGroup.value?.[0]?.nostoSlot || ''
      );
      const TRUNCATED_LINES = {
        mobile: 2,
        desktop: 3
      };
      const truncatedLines = computed<number>(() =>
        isDesktop.value ? TRUNCATED_LINES.desktop : TRUNCATED_LINES.mobile
      );
      const uid = computed(() => 'he_' + (props.sectionData.sys?.id || ''));
      const sliderProps = ref({
        slider: {
          mobileShift: 25,
          arrows: true,
          arrowsSize: 20,
          arrowsIconPrev: 'chevronleft',
          arrowsIconNext: 'chevronright',
          arrowsType: 'contextual'
        }
      });
      const altVisuals = computed(
        () => props.sectionData?.productGroup?.altvisCollection?.items || []
      );

      return {
        isDesktop,
        heading,
        headingLink,
        description,
        truncatedLines,
        productsSKU,
        productGroup,
        sliderProps,
        altVisuals,
        uid,
        nostoSlot,
        skuListType
      };
    }
  }
);
